import * as React from 'react';
import ProductListing from '../ProductListing';
import { getListableProducts } from '../ajax/getListableProducts';
import type { Product } from '../types/Product';

interface IListingsProps {
  catalog_number: number;
}

export default function Listings(props: IListingsProps): JSX.Element {
	const [listable_products, setListableProducts] = React.useState<Array<Product>>([]);
	const [qty, setQty] = React.useState(1);

	React.useEffect(() => {
    async function fetchData() {
      const response = await getListableProducts(props.catalog_number);
      setListableProducts(response.listable_vendor_products);
    }
    fetchData();
	}, []);

	const changeQty = (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    
    if (parseInt(value) > listable_products[index].qty) {
      setQty(listable_products[index].qty);
    } else {
      setQty(parseInt(value));
    }
	};

	const submit = (vendor_id: number, product_id: number) => () => {
    if (qty > 0) {
      const url = '/marketplace/vendors/' + vendor_id +'/storefront?products=' + product_id + '|' + qty;
      
      window.location.href = url;
    }
  };

	if (listable_products.length > 0) {
		const header = listable_products.length === 1 ? 'this vendor' : 'these vendors';
		
		return (
			<div className="_vendorWrapper">
				<h3>Also sold by {header}:</h3>
				<div className="_vendorListings">
					{listable_products.map((product, index) => (
            <ProductListing
              key={product.id}
              product={product}
              qty={qty}
              changeQty={changeQty(index)}
              handleSubmit={submit(product.vendor_id, product.id)}
            />
          ))}
				</div>
			</div>
		);
	} else {
		return <div></div>;
	}
}
